import ScatterGraph from "./ScatterGraph";
export default ScatterGraph;
